import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M1 11.064c.001 4.95 3.578 9.164 8.437 9.94v-7.032H6.9v-2.908h2.54V8.851a3.563 3.563 0 0 1 .971-2.853 3.516 3.516 0 0 1 2.802-1.071c.75.012 1.499.08 2.24.201v2.474h-1.264a1.44 1.44 0 0 0-1.19.393 1.46 1.46 0 0 0-.438 1.18v1.89h2.77l-.442 2.908H12.56v7.031c5.254-.835 8.938-5.664 8.384-10.987C20.39 4.694 15.79.739 10.479 1.018 5.166 1.297 1 5.712 1 11.064Z" />
  </svg>
);
